import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OpenPQLButton } from '../../shared/OpenPQLButton';
import { TranscriptContext } from '../../../contexts/TranscriptContext';
import { BlurredTranscript } from './BlurredTranscript';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TranscriptPQL = () => {
  const {
    hasSalesStarterSeat,
    hasServiceStarterSeat
  } = useContext(TranscriptContext);
  const umsModalId = hasServiceStarterSeat && !hasSalesStarterSeat ? 'recording-review-transcript-empty-state-service-hub' : 'recording-review-transcript-empty-state-sales-hub';
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "transcriptPQL",
    children: [/*#__PURE__*/_jsx(BlurredTranscript, {}), /*#__PURE__*/_jsx(OpenPQLButton, {
      modalId: umsModalId,
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.transcriptPQL.buttonText"
      })
    })]
  });
};